export const DOMAIN = "https://miniapp2.52ywy.com/"
export const R2DOMAIN = "https://s1.52ywy.com"


//测试
//export const DOMAIN ="https://miniapp2.ywylv.com/"

